/**
 * The Fias arche a platform link opens for a job (ADR-037 D8) — e.g. the
 * creative studio, FiasWorks Studio. Null while none is assigned in this
 * environment or this person cannot open it; the server decides both.
 */
import { useQuery } from '@tanstack/react-query';
import { api, type FiasArcheRole } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

export function useFiasArche(role: FiasArcheRole) {
  return useQuery({
    queryKey: queryKeys.fiasArches.role(role),
    queryFn: async () => (await api.getFiasArche(role)).arche,
    // An admin setting that rarely moves; a failure just hides the link.
    staleTime: 5 * 60_000,
    retry: false,
  });
}
